package br.com.vvrefeicoes.portal.core.network

actual val apiBaseUrl: String = "https://portalvv.teste.api.vvrefeicoes.com.br"
